module.exports = {"company":"<a>Dun & Bradstreet Czech Republic, a.s.</a>","support":"<a>Zákaznícky servis</a>"}